var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01074 6.58847C5.62646 4.47439 11.5996 1.8969 12.4241 1.54015C14.5869 0.606428 15.2505 0.785373 14.9196 2.85318C14.682 4.33942 13.9963 9.26003 13.4498 12.3227C13.1256 14.139 12.398 14.3542 11.254 13.5685C10.7038 13.1903 7.92698 11.2785 7.32431 10.8296C6.77415 10.4205 6.01539 9.9284 6.96696 8.95911C7.30558 8.61384 9.5253 6.40723 11.2547 4.68966C11.4813 4.46407 11.1967 4.09356 10.9352 4.27442C8.60421 5.88378 5.37232 8.11753 4.96099 8.40851C4.33958 8.84784 3.74279 9.04935 2.67149 8.72893C1.86205 8.48689 1.07134 8.19821 0.763573 8.08809C-0.421576 7.66443 -0.140254 7.11575 1.01074 6.58847Z",
    fill: "#C0C2CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTelegram);
export default __webpack_public_path__ + "static/media/menu-telegram.5b7230a2d67f8a5d4d5457625d1b18d6.svg";
export { ForwardRef as ReactComponent };